export default __webpack_public_path__ + "static/media/mad-ape-010.1e840060.svg";